<template>
  <div class="proposition-params">
    <div class="proposition-params__main">
      <div class="proposition-params__product">
        <p class="proposition-params__product-value">
          Страхування домашніх тварин "Кіт і Пес"
          <HelpTooltip
            class="proposition-params__product-tooltip"
            text="Страховий продукт для домашніх тварин (коти та собаки)"
          />
        </p>
      </div>
      <div v-if="insurancePeriodName" class="proposition-params__period">
        <p class="proposition-params__period-value">
          {{ insurancePeriodName }}
          <HelpTooltip
            class="proposition-params__period-tooltip"
            text="Період дії страхового поліса"
          />
        </p>
        <p class="proposition-params__period-label">Період дії договору</p>
      </div>
    </div>

    <WhiteButton
      class="proposition-params__toggle"
      @click="$emit('toggle-details', !openDetails)"
    >
      Детальніше про поліс
      <span
        :class="clsx(
          'proposition-params__toggle-icon',
          { 'proposition-params__toggle-icon--rotated': openDetails }
        )"
      >
        <OpenDownIcon color="#0A77FF" />
      </span>
    </WhiteButton>
  </div>
</template>

<script>
import clsx from 'clsx';
import { petsPeriodLabels } from '@/entities/insurance/config';
import { HelpTooltip, WhiteButton } from '@/shared/ui/form';
import { OpenDownIcon } from '@/shared/ui/icons';

export default {
  props: {
    openDetails: {
      type: Boolean,
      default: false,
    },
    insurancePeriod: {
      type: String,
      default: '',
    },
  },
  components: { OpenDownIcon, HelpTooltip, WhiteButton },
  methods: { clsx },
  computed: {
    insurancePeriodName() {
      return petsPeriodLabels[this.insurancePeriod] || this.insurancePeriod;
    },
  },
};
</script>

<style scoped lang="scss">
.proposition-params {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 20px 24px;
  border-left: 1px solid #cbd5e1;
  border-right: 1px solid #cbd5e1;

  @media (max-width: 800px) {
    width: 100%;
    border-left: none;
    border-right: none;
    padding: 0 16px;
    margin-bottom: 16px;
  }

  @media (max-width: 500px) {
    margin-bottom: 0;
  }

  &__main {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;

    @media (max-width: 600px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }
  }

  &__product {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__product-value {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: 500;
    margin: 0 0 4px;
  }

  &__product-tooltip {
    margin-left: 4px;
  }

  &__product-label {
    font-size: 14px;
    font-weight: 400;
    color: #717680;
    margin: 0;
  }

  &__period {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__period-value {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: 500;
    margin: 0 0 4px;
  }

  &__period-tooltip {
    margin-left: 4px;
  }

  &__period-label {
    font-size: 14px;
    font-weight: 400;
    color: #717680;
    margin: 0;
  }

  &__toggle {
    width: 100%;
    color: #0a77ff;
    padding: 12px;
    margin-top: auto;

    &:focus {
      box-shadow: none;
    }
  }

  &__toggle-icon {
    display: inline-flex;
    margin-left: 8px;
    transition: transform 0.3s ease-in-out;

    &--rotated {
      transform: rotate(180deg);
    }
  }
}
</style>
